import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

// Lọc tổng hợp công
export function locTongHopCong(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/cham-cong/tong-hop/', { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy tổng hợp công
export function layTongHopCong(id: number) {
  try {
    return axiosApi.get('/cham-cong/tong-hop/' + id)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy tổng hợp công nhân viên
export function layTongHopCongNhanVien(userId: number, querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/cham-cong/tong-hop/nhan-vien/' + userId, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật tổng hợp công
export function capNhatTongHopCong(id: number, params: any) {
  try {
    return axiosApi.put('/cham-cong/tong-hop/' + id, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xác nhận tổng hợp công
export function xacNhanTongHopCong(id: number) {
  try {
    return axiosApi.put('/cham-cong/tong-hop/' + id + '/xac-nhan')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tính toán tổng hợp công
export function tinhToanTongHopCong(params: any) {
  try {
    return axiosApi.post('/cham-cong/tong-hop/tinh-toan', params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
